import React, { useState } from "react";
import { useDispatch } from "react-redux";
import IndexNav from "../../IndexNav";
import { openAlert } from "../../../Redux/Slices/alertSlice";
import { submitFeedback } from "../../../Services/engagementService";
import {
  Bullet,
  BulletList,
  Button,
  Content,
  Description,
  FooterText,
  Form,
  FormCard,
  Input,
  Intro,
  IntroText,
  IntroTitle,
  Page,
  Row,
  Select,
  TextArea,
  Title,
} from "./Styled";

const Feedback = () => {
  const dispatch = useDispatch();
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    type: "feedback",
    content: "",
  });

  const onChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await submitFeedback(formData);
      dispatch(
        openAlert({
          message: "Thank you. Your submission has been saved.",
          severity: "success",
        })
      );
      setFormData({
        name: "",
        email: "",
        type: "feedback",
        content: "",
      });
    } catch (error) {
      dispatch(
        openAlert({
          message: error?.response?.data?.errMessage ? error.response.data.errMessage : error.message,
          severity: "error",
        })
      );
    }
    setSubmitting(false);
  };

  return (
    <>
      <IndexNav />
      <Page>
        <Content>
          <Intro>
            <IntroTitle>Submit feedback or feature requests</IntroTitle>
            <IntroText>
              Share anything that helps us improve PepHub Board. Every submission is saved to our
              internal database for product planning.
            </IntroText>
            <BulletList>
              <Bullet>Choose "Feedback" for UX, bugs, or improvement notes.</Bullet>
              <Bullet>Choose "Feature request" for capabilities you want next.</Bullet>
              <Bullet>Include context or examples so we can prioritize correctly.</Bullet>
            </BulletList>
          </Intro>
          <FormCard>
            <Form onSubmit={onSubmit}>
              <div>
                <Title>Tell us what you need</Title>
                <Description>This page stores submissions in the database only.</Description>
              </div>
              <Row>
                <Input
                  required
                  placeholder="Your name"
                  value={formData.name}
                  onChange={(e) => onChange("name", e.target.value)}
                />
                <Input
                  required
                  type="email"
                  placeholder="Your email"
                  value={formData.email}
                  onChange={(e) => onChange("email", e.target.value)}
                />
              </Row>
              <Select value={formData.type} onChange={(e) => onChange("type", e.target.value)}>
                <option value="feedback">Feedback</option>
                <option value="feature_request">Feature request</option>
              </Select>
              <TextArea
                required
                placeholder="Describe your feedback or requested feature..."
                value={formData.content}
                onChange={(e) => onChange("content", e.target.value)}
              />
              <Button type="submit" disabled={submitting}>
                {submitting ? "Submitting..." : "Submit"}
              </Button>
              <FooterText>Need to publish public praise? Use the Reviews page.</FooterText>
            </Form>
          </FormCard>
        </Content>
      </Page>
    </>
  );
};

export default Feedback;
